import { type CalendarItem } from './types'

export type QuickfindMatcher = (item: CalendarItem) => boolean

/**
 * Builds the test behind quickfind, or `null` when nothing was typed.
 *
 * Quickfind dims what does not match and never removes it, so the month keeps
 * its shape while a person hunts through it. `null` says "everything matches",
 * which lets a caller skip the work altogether rather than run a test that can
 * only answer yes — and makes "an empty box dims the whole month" impossible.
 */
export const buildQuickfindMatcher = (
  quickfind: string | undefined
): QuickfindMatcher | null => {
  const needle = quickfind?.trim().toLowerCase()
  if (!needle) return null

  return (item) =>
    item.title.toLowerCase().includes(needle) ||
    item.searchText?.toLowerCase().includes(needle) === true
}
